import { Box, InputLabel } from '@mui/material'

import DatePickerController from '../../../../components/CustomDatepicker/CustomDatePicker';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import { InputControllerWithIcon } from '../../../../components/InputController/InputController';
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController';
import React from 'react'
import { facilityType } from './formOptions';

const FacilitySection = (props) => {
    const {errors, control, getValues} = props;
  return (
    <>
           <Box sx={{ display:"flex", justifyContent:"center", flexDirection: "column", gap:"1rem", alignItems:"center", my:2, }}>
                              
                              <Box sx={{ display: "flex", gap:"0.5rem" }}>
                              <InputControllerWithIcon
                                    name="facility_name"
                                    label="Facility Name"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            />   

                                    <InputControllerWithIcon
                                    name="facility_name"
                                    label="Nurse Name"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            />  
                            </Box>

                            <Box sx={{ display: "flex", gap:"1rem", alignItems: "center", flexWrap: "wrap"}}> 
                            <InputLabel sx={{ color: (theme)=>theme.palette.black.main, fontWeight:"bold"}}>Facility Type :</InputLabel>
                            <RadioButtonController
                                name="facility_type"
                                label="Facility Type"
                                control={control}
                                errors={errors}
                                options={facilityType}
                                isRow={true}
                                isDisabled={true}
                            />     
                            <DatePickerController name="facility_date"
                             label="Test Date"
                              control={control}
                               errors={errors}
                                readOnly={true}
                                getValues={getValues}
                                 />
                            </Box>
                </Box>  
    </>
  )
}

export default FacilitySection